import { render, staticRenderFns } from "./RequestRoadsButtons.vue?vue&type=template&id=2eb244e5&scoped=true&"
import script from "./RequestRoadsButtons.vue?vue&type=script&lang=js&"
export * from "./RequestRoadsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb244e5",
  null
  
)

export default component.exports
import {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
